export const RELOAD_SERVER_TABLE = 'RELOAD_SERVER_TABLE'
export const RELOADED_SERVER_TABLE = 'RELOADED_SERVER_TABLE'
export const SERVER_TABLE_EMIT = 'server-table-loaded'
export const RESULTS_EXCEDE_MAX_ALLOWED = 'RESULTS_EXCEDE_MAX_ALLOWED'
export const MAX_ALLOWED_PAGE_REACHED = 'MAX_ALLOWED_PAGE_REACHED'
export const ERROR_RETRIEVING_RESULTS = 'ERROR_RETRIEVING_RESULTS'
